import { motion } from "framer-motion";

export const LOGO_URL = "/gabicom-logo.png?v=4";

// Smooth scroll to a section id (works with Lenis when available)
export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
  else el.scrollIntoView({ behavior: "smooth" });
}

export function scrollToTop() {
  if (window.__lenis) window.__lenis.scrollTo(0);
  else window.scrollTo({ top: 0, behavior: "smooth" });
}

// Scroll reveal wrapper — words & blocks "flow in" as the user scrolls
export function Reveal({ children, delay = 0, y = 48, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y, filter: "blur(8px)" }}
      whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

// Directional flow-in (for images sliding in from the side)
export function RevealSide({ children, from = "right", delay = 0, className = "" }) {
  const x = from === "left" ? -70 : 70;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, x, filter: "blur(10px)" }}
      whileInView={{ opacity: 1, x: 0, filter: "blur(0px)" }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

// Heading text that flows in word-by-word with a mask reveal
export function RevealWords({ text, className = "", delay = 0, as: Tag = "h2" }) {
  const words = text.split(" ");
  const MC = motion[Tag] || motion.h2;
  const container = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.07, delayChildren: delay } },
  };
  const word = {
    hidden: { y: "110%", opacity: 0 },
    visible: {
      y: "0%",
      opacity: 1,
      transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
    },
  };
  return (
    <MC
      className={className}
      variants={container}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-60px" }}
    >
      {words.map((w, i) => (
        <span key={i} className="inline-block overflow-hidden align-bottom">
          <motion.span className="inline-block" variants={word}>
            {w}&nbsp;
          </motion.span>
        </span>
      ))}
    </MC>
  );
}

// Section eyebrow / overline
export function Overline({ children }) {
  return (
    <span className="font-mono-tech text-xs uppercase tracking-[0.35em] text-[#00f0ff]">
      {children}
    </span>
  );
}
